'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {FilterInput} from '../../../components/lists/FilterInput';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {isTaskType, TaskType} from '../../../tasks/enums/TaskType';
import {AssetProjectList} from '../AssetProjectList';
import {ProjectNavigationBar} from '../ProjectNavigationBar';


export function BaseProjectViewAssetsView(props) {
  return (
    <ProjectLayout
      className={classNames("ProjectViewAssets", props.className)}
      title={props.viewTitle}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={(
        <FilterInput
          showFilterOptions={true}
          searchOnly={false}
          filterModalOptions={props.filterModalOptions}

          autoFilter={props.autoFilter}
          onFilterChange={props.onFilterChange}
          onChangeDebounce={450}
          onFilterOptionsUpdate={props.onFilterOptionsUpdate}
          onSortOptionsUpdate={props.onSortOptionsUpdate}
        />
      )}
      headerRightContent={(
        <Fragment>
          <div className="ProjectViewAssets__desktopButtons">
            <Button
              className="ProjectViewAssets__addTaskButton"
              label={props.assetsManageLabel}
              onClick={props.onNavToManageAssets}
            />
          </div>
          <Button
            className="ProjectViewAssets__headerButton"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={(
        <ProjectNavigationBar
          taskType={TaskType.PROJECT}
          target={props.project}
        />
      )}
      bannerContent={null}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
    >
      <AssetProjectList
        transitionGroupClass="ProjectLayout__content__container"
        itemClassName="ProjectLayout__content__item"
        list={props.list}
        useScroll={false}
        mode={props.mode}
        onLoadMore={props.onLoadMore}
        userId={props.userId}
        taskType={props.taskType}

        onClickItem={props.onClickItem}
        onItemContextMenu={props.onItemContextMenu}

        init={props.init}
      />
    </ProjectLayout>
  );
}

BaseProjectViewAssetsView.propTypes = {
  className: T.string,
  breadcrumbPath: T.array,
  userId: T.string.isRequired,
  taskType: isTaskType.isRequired,
  parentId: T.string,

  onClickOptions: T.func.isRequired,
  onClickItem: T.func.isRequired,
  onItemContextMenu: T.func.isRequired,

  viewTitle: T.string,
  assetsManageLabel: T.string,

  init: T.bool,
};

BaseProjectViewAssetsView.defaultProps = {
  init: true,
};

export const ProjectViewAssetsView = I18nComponent(BaseProjectViewAssetsView, [
  {code: 'projects.views.assets.title', prop: 'viewTitle'},
  {code: 'projects.home.context.assets.manage.label', prop: 'assetsManageLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectViewAssets/ProjectViewAssetsView.js